const baseState = {
    snapshotList: [],
    modifyingDateTimeArray: [],
    selectedSnapshotIndex: 0,
    currentClientState: null
}

const clientHistoryReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_CLIENT_SNAPSHOT_LIST": {
			return {
				...state,
				snapshotList: payload
			}
		}

		case "CLEAR_CLIENT_SNAPSHOT_LIST": {
			return {
				...state,
				usersList: []
			}
		}

		case "SET_CLIENT_MODIFYINGDATE_TIME_ARRAY": {
            return {
                ...state,
                modifyingDateTimeArray: payload
            }
        }

        case "SET_CLIENT_SELECTED_SNAPSHOT_INDEX": {
            return {
                ...state,
                selectedSnapshotIndex: payload
            }
        }

        case "SET_CURRENT_CLIENT_STATE": {
			return {
				...state,
				currentClientState: payload
			}
		}

        default:
            return state;
    }
}

export default clientHistoryReducer